import { Box } from '@chakra-ui/react';
import { DashboardTemplate } from '../../components/templates/DashboardTemplate.tsx';
import { ProductsAndPlans } from '../ProductsAndPlans/index.tsx';

export default function ModulosPage() {
  return (
    <DashboardTemplate>
      <Box width="100%" maxW="100%" padding={4}>
        <ProductsAndPlans />
      </Box>
    </DashboardTemplate>
  );
}
